export default "__VITE_ASSET__QIzHLioC__"